require('./bootstrap')

import Vue from 'vue';
import vuetify from './../../src/plugins/vuetify'
import moment from 'moment';

import { InertiaApp } from '@inertiajs/inertia-vue';
import { InertiaForm } from 'laravel-jetstream';
import PortalVue from 'portal-vue';
import { VTextField } from 'vuetify/lib';
import { VSelect } from "vuetify/lib";

import VueSplide from '@splidejs/vue-splide';

import { parsePhoneNumberFromString } from 'libphonenumber-js'

Vue.mixin({ methods: { route } })
Vue.use(InertiaApp)
Vue.use(InertiaForm)
Vue.use(PortalVue)
Vue.use( VueSplide )
Vue.mixin(require('./Mixins/Translate'))

const app = document.getElementById('app')
window.moment = moment

var vm = new Vue({
    vuetify,
    render: (h) =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: (name) => require(`./Pages/${name}`).default,
            },
        }),
    data() {
        return {
            lang: window.lang,
            is_dirty: false,
            user_role: null,
        }
    },
    methods: {
        onBeforeUnload(e) {
            // Cancel the event
            e.preventDefault()
            // Chrome requires returnValue to be set
            e.returnValue = ''
        },

        activateReloader() {
            window.addEventListener('beforeunload', this.onBeforeUnload);
            console.log("Now activating reloader")
        },

        deactivateReloader() {
            window.removeEventListener('beforeunload', this.onBeforeUnload);
        },

        sanitizeAndTruncateHTML(html, maxLength) {
            if( typeof html !== "string" ) {
                return ''
            }
            // Remove html tags
            const sanitizedHTML = html.replace(/<(?:.|\n)*?>/gm, '')
            // Truncate text
            let truncatedText = sanitizedHTML.slice(0, maxLength)

            if (sanitizedHTML.length > maxLength) {
                truncatedText += ' ...'
            }
            return truncatedText
        },

        truncateHTML(html, maxLength) {
            if (typeof html !== 'string') {
                return ''
            }

            let parser = new DOMParser()
            let doc = parser.parseFromString(html, 'text/html')
            let result = ''

            function traverseNodes(node) {
                if (result.length >= maxLength) {
                    return
                }

                if (node.nodeType === Node.TEXT_NODE) {
                    let text = node.textContent
                    if (result.length + text.length > maxLength) {
                        text = text.slice(0, maxLength - result.length) + '...'
                    }
                    result += text
                } else if (node.nodeType === Node.ELEMENT_NODE) {
                    for (let childNode of node.childNodes) {
                        traverseNodes(childNode)
                        if (['DIV', 'P'].includes(node.nodeName) && node.textContent.trim() !== '' && !result.endsWith('<br><br>')) {
                            result += '<br>'
                        }
                        if (result.length >= maxLength) {
                            break
                        }
                    }
                }
            }

            traverseNodes(doc.body)
            // Replace three or more consecutive <br> (with possible intervening whitespace) with two <br>
            result = result.replace(/(\s*<br>\s*){3,}/g, '<br><br>')
            return result
        },

        smartDate(date) {
            let now = new Date()
            let inputDate = new Date(date)

            inputDate.setMinutes(inputDate.getMinutes() + inputDate.getTimezoneOffset())

            now.setHours(0, 0, 0, 0)
            inputDate.setHours(0, 0, 0, 0)

            let diffInDays = (now - inputDate) / (1000 * 60 * 60 * 24)
            let formattedDate

            let monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];

            if (diffInDays === 0) {
                formattedDate = 'Today'
            } else if (diffInDays === 1) {
                formattedDate = 'Yesterday'
            } else {
                let day = inputDate.getDate()
                let month = monthNames[inputDate.getMonth()] // get the name of the month
                let year = inputDate.getFullYear()

                // if (now.getFullYear() === year) {
                //     formattedDate = `${month} ${day}`
                // } else {
                    formattedDate = `${month} ${day}, ${year}`
                // }
            }
            return formattedDate
        },
        handleErrors(error) {
            if( error?.response ) {
                const errors = error.response?.data?.errors
                if (errors) {
                    let errorMessages = []
                    for (let field in errors) {
                        if (errors[field].length > 0) {
                            errorMessages.push(errors[field][0])
                        }
                    }
                    const errorMessage = errorMessages.join(' ')
                    this.snackbar.error(errorMessage)
                } else {
                    this.snackbar.error(error.response.data.message)
                }
            } else {
                this.snackbar.error(error)
            }
        },
        getUserRole() {
            return this.$page.user?.role === undefined? 'Guest' : this.$page.user.role
        },
        getAsIsoDate(datestring) {
            let mom = moment(datestring)
            let valid_check = mom?.isValid()
            return valid_check ? mom.format('Y-MM-DD') : null
        },
        formatCurrency(value) {
            let dollar = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
            })
            return dollar.format(value)
        },
        formatPhoneNumeric(tel) {
            if (!tel) {
                return tel
            }
            return tel.replace(/[^\d+]/g, "")
        },
        formatPhoneDisplay(number_input, defaultCountry = 'CA') {
            if (!number_input || typeof number_input !== 'string') {
                return number_input
            }

            try {
                const phoneNumber = parsePhoneNumberFromString(number_input, defaultCountry)

                if (phoneNumber && phoneNumber.isValid()) {
                    // If it's a US or Canadian number, use national format (e.g., (416) 835-7637)
                    if (phoneNumber.country === 'US' || phoneNumber.country === 'CA') {
                        return phoneNumber.formatNational()
                    }

                    // Otherwise, use international format
                    return phoneNumber.formatInternational()
                }
            } catch (e) {
                console.warn('Phone formatting error:', e)
            }

            // Soft fallback ONLY for 10-digit US-style numbers
            const digits = number_input.replace(/\D/g, '')
            if (digits.length === 10) {
                return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
            }

            // Otherwise, return raw input
            return number_input
        },

    },
    watch: {
        is_dirty: {  // Watch for data changes on the page
            handler(newVal, oldVal) {
                if (newVal) {
                    // Activating the reloader will prevent the user from navigating away
                    this.activateReloader()
                }
                if (!newVal) {
                    // Deactivating the reloader will once again allow the user to navigate away freely
                    this.deactivateReloader()
                }
            },
            deep: false,
            immediate: false,
        },
    },
}).$mount(app);

Vue.component('VTextField', {
    extends: VTextField,
    props: {
        dense: {
            type: Boolean,
            default: true
        },
        outlined: {
            type: Boolean,
            default: true
        },
        rounded: {
            type: Boolean,
            default: false
        },
        backgroundColor: {
            type: String,
            default: '#FFF'
        },
        staticClass: "tw-border tw-border-black",
    }
})
Vue.component('VSelect', {
    extends: VSelect,
    props: {
        dense: {
            type: Boolean,
            default: true
        },
        outlined: {
            type: Boolean,
            default: true
        },
        backgroundColor: {
            type: String,
            default: '#FFF'
        },
        staticClass: "font-semibold text-gray-900 uppercase w-36",
    }
})
